module.exports = __webpack_public_path__ + "static/img/balzw969.623db74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balzw969.jpg
// module id = 6U5L
// module chunks = 0